const dashboard = {
  bannerTitle: 'Painel em evolução',
  bannerDescription:
    'Os widgets da visão geral serão alimentados por dados reais conforme os endpoints do dashboard forem disponibilizados.',
  cardDescription: 'Sem dados simulados. Esta tela exibirá informações reais do backoffice.',
  emptyState: {
    title: 'Nenhum indicador disponível',
    description:
      'Conecte os endpoints do dashboard para visualizar métricas, atividades e alertas.',
  },
}

export default dashboard
